import StepCompletionCard from '@cohort/merchants/apps/StepCompletionCard';
import type {GarminConnectBeActiveVerificationAttemptData} from '@cohort/shared/apps/garmin-connect/triggers/beActive';

const GarminConnectBeActiveTriggerIntegrationStepCompletionTitleComponent: React.FC<{
  data: GarminConnectBeActiveVerificationAttemptData;
  completionSuccess: boolean;
}> = ({data, completionSuccess}) => (
  <StepCompletionCard
    translationConfig={{
      // i18nOwl-ignore [app-garmin-connect.triggerIntegrations.be-active.stepCompletionTitleComponent.success]
      // i18nOwl-ignore [app-garmin-connect.triggerIntegrations.be-active.stepCompletionTitleComponent.error]
      key: `triggerIntegrations.be-active.stepCompletionTitleComponent.${
        completionSuccess ? 'success' : 'error'
      }`,
      ns: 'app-garmin-connect',
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      value: data === null ? 'N/A' : data.garminUsername!,
    }}
  />
);

export default GarminConnectBeActiveTriggerIntegrationStepCompletionTitleComponent;
